module.exports = __webpack_public_path__ + "img/51.787d9806.png";